$(() => {
    let cookieMessage = $('#cookieMessage');
    let cookieName = 'accept_cookies';

    // Handle the cookie close click
    $('body').on('click', '#cookieClose', () => {

        // Get the cookie ttl
        let cookieTtl = cookieMessage.data('ttl');

        // Set the cookie ttl
        Cookies.set(cookieName, 'accepted', {
            expires: cookieTtl
        });

        // Remove cookie from dom
        cookieMessage.remove();
    });

    // If the cookie is undefined, the show the cookie.
    if(typeof Cookies.get(cookieName) === 'undefined') {
        cookieMessage.show();
    }
});


// WEBPACK FOOTER //
// ./resources/js/components/cookie.js